import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.css'],
})
export class MessageModalComponent implements OnInit {

  @ViewChild('messageModal', { static: false }) messageModal: ModalDirective;

  readonly SCREEN_ID = 'O82';

  public message: SafeHtml;

  public observer: Observer<boolean>;

  public observable: Observable<boolean>;

  constructor(private sanitizer: DomSanitizer) {
    this.observable = new Observable(observer => { this.observer = observer; });
  }

  ngOnInit() {
  }

  showMessageModal(message: string): Observable<boolean> {

    this.message = this.sanitizer.bypassSecurityTrustHtml(message);
    this.messageModal.show();

    return this.observable;
  }

  hideMessageModal(): void {

    this.messageModal.hide();
    this.observer.next(true);
  }
}
